/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Preview_AltInputs */

const en_directory_submit_badge_preview_alt = /** @type {(inputs: Directory_Submit_Badge_Preview_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured on SEEKAI badge`)
};

const zh_directory_submit_badge_preview_alt = /** @type {(inputs: Directory_Submit_Badge_Preview_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured on SEEKAI 徽章`)
};

/**
* | output |
* | --- |
* | "Featured on SEEKAI badge" |
*
* @param {Directory_Submit_Badge_Preview_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_preview_alt = /** @type {((inputs?: Directory_Submit_Badge_Preview_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Preview_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_preview_alt(inputs)
	return zh_directory_submit_badge_preview_alt(inputs)
});
export { directory_submit_badge_preview_alt as "directory.submit.badge_preview_alt" }